<div class="flex-grow-1 user-settings-container border-start border-white py-3 px-0">
  <div class="d-flex align-items-center justify-content-center flex-grow-1 ps-4" id="app-header-ic-us">
    <span class="rounded-circle d-flex align-items-center justify-content-center">
      <span class="d-inline-block fw-bold font-size-16" id="app-header-us-title-initials">{{ userNameInitials }}</span>
    </span>
    <div ngbDropdown [autoClose]="'outside'" placement="bottom-end" class="user-settings-dropdown d-inline-block">
      <i class="bi bi-chevron-down d-inline-block" id="app-header-lnk-us" ngbDropdownToggle role="button" tabindex="0" aria-label="Toggle user menu"></i>
      <ul ngbDropdownMenu aria-labelledby="app-header-lnk-us" class="font-size-14">
        <li class="dropdown-item d-flex align-items-center">
          <span class="rounded-circle d-flex align-items-center justify-content-center" id="app-header-lnk-user-name">
            <span class="d-inline-block fw-bold font-size-16 text-white" id="app-header-us-title-initials">{{ userNameInitials }}</span>
          </span>
          <h6 class="d-inline-block ps-2 mb-0 font-size-14" id="app-header-us-mdl-useremail">{{ userEmailName }} </h6>
        </li>
        <li>
          <hr class="dropdown-divider" />
        </li>
        <li>
          <a class="dropdown-item d-flex align-items-center justify-content-between cursor-pointer fw-bold py-2" id="app-header-us-btn-my-access" (click)="openMyAccess()">
            <span><i class="bi bi-database pe-2" aria-hidden="true"></i>My access &amp; scopes</span>
            @if (scopeCount() !== null) {
              <span class="badge rounded-pill text-bg-secondary font-monospace" id="app-header-us-badge-scopes">{{ scopeCount() }}</span>
            }
          </a>
        </li>
        <li>
          <a class="dropdown-item d-flex align-items-center cursor-pointer fw-bold py-2" id="app-header-us-btn-my-tokens" *ngxPermissionsOnly="'token-read'" (click)="navigateToMyTokens()">
            <i class="bi bi-key pe-2" aria-hidden="true"></i>My API tokens
          </a>
        </li>
        <li>
          <a class="dropdown-item d-flex align-items-center cursor-pointer fw-bold py-2" id="app-header-us-btn-create-token" *ngxPermissionsOnly="'token-write'" (click)="openIssueTokenForMe()">
            <i class="bi bi-plus pe-2" aria-hidden="true"></i>Create a token for me
          </a>
        </li>
        <li>
          <hr class="dropdown-divider" />
        </li>
        <li class="text-center">
          <a class="dropdown-item link-primary cursor-pointer fw-bold" id="app-header-us-btn-logout" (click)="logout()">{{ headerContents.profileRedirectData.logout }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>
